import { Provider } from 'react-redux';
import { i18nReducer, loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { combineReducers } from 'redux';

import { createStore, createReducer } from '@common/utils/redux';
import { setAppConfig } from "@common/utils/config";

import { pedigreesEN } from './translations/en';
import { pedigreesES } from './translations/es';
import { pedigreesJA } from './translations/ja';
import { Pedigrees } from './pedigrees';
import { mountReactNode } from '@common/utils/react';

export * from './pedigrees';

export const initPedigrees = (
  componentId,
  locale,
  liveSearchEnabled,
  liveSearchDelay
) => {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
    syncTranslationWithStore(store);

    setAppConfig({
      pedigrees: {
        liveSearchEnabled,
        liveSearchDelay,
      }
    });
  
    const translation = {
      en: pedigreesEN,
      ja: pedigreesJA,
      es: pedigreesES,
    };
  
    if (!translation[locale]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
  
    mountReactNode(
      <Provider store={store}>
        <Pedigrees />
      </Provider>,
      document.getElementById(componentId)
    );
  } catch(err) {
    throw err;
  }
};